// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PopupInfo_overlay__1gnQo","wrapper":"PopupInfo_wrapper___Yk4o","info":"PopupInfo_info__KfDHG"};